import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class ProductPrice extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  #handleProductSelect = (event) => {
    if (
      !(event.target instanceof Element) ||
      event.target.closest('product-card')
    ) {
      return;
    }

    /*
     * Get the selected variant immediately.
     * The variant picker already knows which option was selected.
     */
    const variantId =
      event.detail?.variantId ||
      event.detail?.variant?.id ||
      event.target
        ?.querySelector('input[type="radio"]:checked')
        ?.dataset?.variantId ||
      event.target
        ?.querySelector('select option:checked')
        ?.dataset?.variantId;

    if (!variantId) return;

    /*
     * Keep Shopify's normal event flow.
     * The actual price HTML is replaced from the fetched section.
     */
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (
          detail.productId &&
          detail.productId !== this.dataset.productId
        ) {
          return;
        }

        const { priceContainer, volumePricingNote } = this.refs;

        const newProductPrice = html.querySelector(
          `product-price[data-block-id="${this.dataset.blockId}"]`
        );

        if (!newProductPrice) return;

        const newPrice = newProductPrice.querySelector(
          '[ref="priceContainer"]'
        );

        /*
         * Replace price immediately when the new variant HTML arrives.
         */
        if (newPrice && priceContainer) {
          priceContainer.replaceWith(newPrice);
        }

        /*
         * Volume pricing
         */
        const newNote = newProductPrice.querySelector(
          '[ref="volumePricingNote"]'
        );

        if (!newNote) {
          volumePricingNote?.remove();
        } else if (!volumePricingNote) {
          newPrice?.insertAdjacentElement(
            'afterend',
            newNote.cloneNode(true)
          );
        } else {
          volumePricingNote.replaceWith(newNote);
        }

        /*
         * Update installment variant ID
         */
        const installmentsInput =
          this.querySelector(
            `#product-form-installment-${this.dataset.blockId} input[name="id"]`
          );

        if (installmentsInput) {
          installmentsInput.value = detail.resource?.id ?? '';

          installmentsInput.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn(
            '[product-price] Event promise rejected:',
            error
          );
        }
      });
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}